<template>
  <div class="user-bar" :class="$store.getters['userStore/getProfileColor'] + (levelUp ? ' level-up': '')" :style="{animationDelay: levelUp ? '' : delayAnimation +'s'}" :key="userDataStore.level">
    <div class="user-bar-header flex space-between">
      <h1 class="username">{{userDataStore.username}}</h1>
      <div class="text-end">
        <small>Performance </small>
        <div>
          <transition name="slide-bottom">
            <small class="inline-block" v-if="performanceUp">  <b>{{performanceDiff}}</b> <i class="fas fa-arrow-right"></i> </small>
          </transition>
          <b> {{userDataStore.performancePoint}}</b>
        </div>
      </div>
    </div>
    <div class="level-data">
      <div class="flex space-between">
        <div :class="{'level-up': levelUp}">
          <span>Level <b>{{userDataStore.level}} </b></span>
          <span class="position-relative" v-if="levelUp">
            <i class="fas fa-arrow-circle-up"></i>
            <i class="level-up-icon fas fa-arrow-circle-up"></i>
          </span>
        </div>
        <span>sisa <b>{{remainingExp}}</b><small>XP</small></span>
      </div>
      <div class="level-bar-overlay">
        <div class="level-bar-fill" :style="{width: percentageBarWidth + '%'}">
          <div class="boxes" v-for="i in 15" :key="i"></div>
        </div>
      </div>
      <div class="text-center">
        <span><b>{{userDataStore.expCurrent}}</b><small>XP</small> / <b>{{userDataStore.expNextLevelTarget}}</b><small>XP</small></span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'userBar',
    data() {
      return {
        levelUp: false,
        performanceUp: false,
        performanceDiff: 0,
        delayAnimation: 0,
      }
    },
    watch: {
      'userDataStore.level'() {
        this.levelUp = true
      },
      'userDataStore.performancePoint'(newVal, oldVal) {
        this.performanceUp = true
        this.performanceDiff = oldVal
      }
    },
    computed: {
      userDataStore() {
        return this.$store.state.userStore
      },
      remainingExp() {
        return this.userDataStore.expNextLevelTarget - this.userDataStore.expCurrent
      },
      percentageBarWidth() {
        return this.userDataStore.expCurrent*100/this.userDataStore.expNextLevelTarget
      }
    },
    created() {
      this.delayAnimation = Math.random() * -10
    }
  }
</script>

<style lang="scss" scoped>
  .user-bar {
    padding: 1rem;
    border-radius: 10px;
    color: white;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-shadow: 0 0 10px rgba(black, 0.2);

    &.level-up {
      animation: flash-mild 2s;
    }
  }

  .user-bar-header {
    margin-bottom: 1rem;
  }

  .blueGradient {
    background-image: linear-gradient(to bottom right, #296f99, #314380);
  }

  .redGradient {
    background-image: linear-gradient(to bottom right, #99263a, #61000a);
  }

  .orangeGradient {
    background-image: linear-gradient(to bottom right, #b87334, #612f02);
  }

  .greenGradient {
    background-image: linear-gradient(to bottom right, #34b847, #1f610f);
  }

  .violetGradient {
    background-image: linear-gradient(to bottom right, #b80083, #61214a);
  }

  .blueGreenGradient {
    background-image: linear-gradient(to bottom right, #2c9c6c, #173d7c);
  }

  .redOrangeGradient {
    background-image: linear-gradient(to bottom right, #c14d00, #6b0003);
  }

  .allColors {
    background: linear-gradient(270deg, #2aa750, #2aa750, #2a6fa7, #432aa7, #a72a9d, #9b2020, #b6831d, #88a72a, #2aa750, #2aa750);
    background-size: 1600% 1600%;
    animation: AnimationName 10s linear infinite;

    @keyframes AnimationName {
      0%{background-position:0 50%}
      100%{background-position:100% 50%}
    }
  }

  .username {
    font-weight: 300;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .level-bar-overlay, .level-bar-fill {
    height: 8px;
    width: 100%;
    border-radius: 10px;
  }

  .level-bar-overlay {
    position: relative;
    background-color: rgba(white, 0.2);
  }

  .level-bar-fill {
    display: flex;
    flex-wrap: nowrap;
    position: absolute;
    top: 0;
    left: 0;
    background-color: white;
    transition: width 0.3s;
    mix-blend-mode: overlay;
    overflow: hidden;
    animation: lighting 2s infinite linear;
  }

  .boxes {
    width: 10px;
    height: 10px;
    margin-right: 10px;
    flex-shrink: 0;
    background-color: white;
    box-shadow: 0 0 5px 5px rgba(white, 0.5);
    animation: floating-right 5s infinite linear;
  }

  .performance-up {
    text-shadow: 0 0 10px rgba(white, 0.5);
    animation: glow-grow 0.5s;
  }

  .level-up {
    text-shadow: 0 0 10px rgba(white, 0.5);
    animation: glow-grow 0.5s;
  }

  .level-up-icon {
    animation: pounding 2s infinite ease-out;
    mix-blend-mode: overlay;
    position: absolute;
    top: 2px;
    left: 0;
  }

  @keyframes lighting {
    0% {
      box-shadow: 0 0 20px 5px rgba(white, 0.85);
      background-color: rgba(white, 0.95);
    }
    50% {
      box-shadow: 0 0 20px 5px rgba(white, 0.45);
      background-color: rgba(white, 0.8);
    }
    100% {
      box-shadow: 0 0 20px 5px rgba(white, 0.85);
      background-color: rgba(white, 0.95);
    }
  }

  @keyframes floating-right {
    from {
      transform: translateX(-20px) skew(-30deg);
    }
    to {
      transform: translateX(0) skew(-30deg);
    }
  }
</style>
